import React, { useEffect, useMemo, useState } from "react";
import "./InterviewScheduling.css";
import { scheduleInterview, getInterviews } from "../services/interviewService";
import API from "../services/api";

const defaultForm = {
  applicationId: "",
  candidateName: "",
  candidateEmail: "",
  interviewType: "VIRTUAL",
  meetingLink: "",
  venue: "",
  date: "",
  time: "",
};

const InterviewScheduling = () => {

  const [formData, setFormData] = useState(defaultForm);
  const [interviews, setInterviews] = useState([]);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    fetchInterviews();
    fetchApplications();
  }, []);

  // ✅ FIXED LIKE JOB MANAGEMENT
  const fetchInterviews = async () => {

    try {

      const res = await getInterviews();

      console.log("Interviews API:", res);

      setInterviews(res.data || []);

    } catch (error) {

      console.error("Error fetching interviews:", error);
      setInterviews([]);

    }
  };

  const fetchApplications = async () => {
    try {

      const res = await API.get("/applications/all");

      setApplications(res.data?.data || []);

    } catch (error) {
      console.error("Error fetching applications:", error);
    }
  };

  const summary = useMemo(() => {

    const total = interviews.length;

    const VIRTUAL = interviews.filter(
      i => i.interview?.interviewType === "VIRTUAL"
    ).length;

    const offline = interviews.filter(
      i => i.interview?.interviewType === "OFFLINE"
    ).length;

    const completed = interviews.filter(
      i => i.status === "Completed"
    ).length;

    return { total, VIRTUAL, offline, completed };

  }, [interviews]);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => {

      const updated = { ...prev, [name]: value };

      if (name === "candidateEmail") {

        const found = applications.find(
          app => app.email?.toLowerCase() === value.toLowerCase()
        );

        if (found) {
          updated.applicationId = found.applicationId || found.id || "";
          updated.candidateName = found.fullName || found.candidateName || "";
        }

      }

      if (name === "interviewType") {
        if (value === "VIRTUAL") updated.venue = "";
        else updated.meetingLink = "";
      }

      return updated;

    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      if (!formData.applicationId) {
        alert("Application ID not found. Please enter correct candidate email.");
        return;
      }

      const payload = {
        roundType: "WRITTEN_TEST",
        interviewType: formData.interviewType.toUpperCase(),
        date: formData.date,
        time: formatTime(formData.time),
        examLink: formData.interviewType === "VIRTUAL" ? formData.meetingLink : "",
        location: formData.interviewType.toUpperCase() === "OFFLINE" ? formData.venue : ""
      };

      await scheduleInterview(formData.applicationId, payload);

      alert("Interview Scheduled Successfully");

      fetchInterviews();
      setFormData(defaultForm);

    } catch (error) {

      console.error("Schedule interview failed:", error);
      alert("Failed to schedule interview");

    }
  };

  const formatTime = (time) => {

    const [hour, minute] = time.split(":");

    const h = parseInt(hour);

    const ampm = h >= 12 ? "PM" : "AM";

    const formattedHour = h % 12 || 12;

    return `${formattedHour}:${minute} ${ampm}`;

  };

  const displayTime = (time) => {

    if (!time) return "";

    if (time.includes("AM") || time.includes("PM")) return time;

    const [hour, minute] = time.split(":");

    const h = parseInt(hour);

    const ampm = h >= 12 ? "PM" : "AM";

    const formattedHour = h % 12 || 12;

    return `${formattedHour}:${minute} ${ampm}`;

  };
  return (
    <div className="interview-page">

      <header className="interview-header">
        <h1>Interview Scheduling</h1>
        <p>Schedule and manage candidate interviews.</p>
      </header>

      <section className="interview-summary">

        <article>
          <span>Total</span>
          <strong>{summary.total}</strong>
        </article>

        <article>
          <span>VIRTUAL</span>
          <strong>{summary.VIRTUAL}</strong>
        </article>

        <article>
          <span>Offline</span>
          <strong>{summary.offline}</strong>
        </article>

        {/* <article>
          <span>Completed</span>
          <strong>{summary.completed}</strong>
        </article> */}

      </section>

      <section className="interview-content">

        {/* FORM */}
        <form className="schedule-form" onSubmit={handleSubmit}>

          <h2>Schedule Interview</h2>

          <label>
            Application ID
            <input
              type="text"
              name="applicationId"
              value={formData.applicationId}
              readOnly
            />
          </label>

          <label>
            Candidate Name
            <input
              type="text"
              name="candidateName"
              value={formData.candidateName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Candidate Email
            <input
              type="email"
              name="candidateEmail"
              value={formData.candidateEmail}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Interview Type
            <select
              name="interviewType"
              value={formData.interviewType}
              onChange={handleChange}
            >
              <option value="VIRTUAL">VIRTUAL</option>
              <option value="offline">Offline</option>
            </select>
          </label>

          {formData.interviewType === "VIRTUAL" ? (
            <label>
              Meeting Link
              <input
                type="url"
                name="meetingLink"
                value={formData.meetingLink}
                onChange={handleChange}
                required
              />
          </label>
        ) : (
          <label>
              Location
              <input
                type="text"
                name="venue"
                value={formData.venue}
                onChange={handleChange}
                required
              />
          </label>
        )}

          <div className="time-grid">

            <label>
              Date
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
          </label>

          <label>
            Time
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </label>

          </div>

          <button type="submit" className="primary-btn">
            Schedule Interview
          </button>

        </form>

        {/* SCHEDULED INTERVIEW DATA */}
        <div className="interview-list-panel">

          <h2>Scheduled Interviews</h2>

          {interviews.length === 0 ? (
            <p>No interviews found</p>
          ) : (

interviews.map((app) => (

  <article key={app.id} className="interview-card">
    
    <p><strong>Name:</strong> {app.fullName}</p>
    <p><strong>Email:</strong> {app.email}</p>

    <p><strong>Date:</strong> {app.interview?.date 
        ? new Date(app.interview.date).toLocaleDateString("en-GB")
        : "Not scheduled"}
    </p>

    <p><strong>Time:</strong> {displayTime(app.interview?.time) || "Not scheduled"}</p>

    <p><strong>Interview Type:</strong> {app.interview?.interviewType || "Not scheduled"}</p>

    {app.interview?.interviewType === "VIRTUAL" ? (
      <p><strong>Meeting:</strong> {app.interview?.meetingLink || app.interview?.examLink}</p>
    ) : (
      <p><strong>Venue:</strong> {app.interview?.location}</p>
    )}

  </article>

))
 

          )}

        </div>

      </section>

    </div>
  );
};

export default InterviewScheduling;
